/** Human tenant owner (not every user with accountType "admin"). */
export const readIsTenantOwnerAdmin = () => {
  try {
    const authUser = JSON.parse(localStorage.getItem("authUser") || "{}")
    return authUser?.isTenantAdmin === true
  } catch {
    return false
  }
}

export const isTenantOwnerAdmin = (flags = {}) => {
  if (flags?.isTenantAdmin === true) return true
  if (flags?.authUser?.isTenantAdmin === true) return true
  return readIsTenantOwnerAdmin()
}
